import React from "react";
import { ConfigContext } from "./configProvider";

export const useConfigState = () => {
  return React.useContext(ConfigContext);
};
